let check: (() => boolean) | null = null;

export function isOnline(): boolean {
  return check ? check() : navigator.onLine;
}

export function setOnlineCheck(fn: (() => boolean) | null): void {
  check = fn;
}
